/**
 * 首页活动
 */
<template>
    <div class="homePageActivityList">
        <!-- 免息好物推荐 -->
        <!-- <Headlines :Text="recommendTitle.Text" :showTitle="recommendTitle.showTitle"></Headlines> -->
        <div
            v-for="(item, index) in homePageActivityList"
            :key="index"
            class="homePageActivityItem"
        >
            <PictureFloatingLayer
                :item="item"
                report-eventid="MInterestFree_GoodsActivePic"
                :report-eventparam="item.activityId"
            ></PictureFloatingLayer>
            <!-- <div v-if="item.recommendGoodsList && item.recommendGoodsList.length">
          <LevelScrollBar :data="item.recommendGoodsList"></LevelScrollBar>
      </div>-->

            <!-- <VerticalSlide
                class="home-vertical-slide"
                :sum="sum"
                :loop="false"
                :data="item.recommendGoodsList"
                v-if="item.recommendGoodsList && item.recommendGoodsList.length"
            >
                <p
                    v-for="item in item.recommendGoodsList"
                    :key="item.id"
                    class="act-htg100"
                    style=""
                    :clstag="'jr|keycount|8530052_index_content_sku|'+item.skuId+''"
                >
                    <KPL
                        class="cls-card cls-card3"
                        style="width:97%;"
                        :url="item.jumpUrl"
                        :sku="item.skuId"
                        :eventId="'MInterestFree_GoodsContentPro'"
                        :eventParam="homePageActivityList[index].activityId+'_'+item.skuId"
                    >
                        <div class="home-silder-img-bg">
                            <div><img
                                    class="act-banner1 act-wthhtg256 act-watch"
                                    v-lazy="item.imageUrl"
                                    lazy="loaded"
                                /></div>
                        </div>
                        <div class="act-table  act-wth256 act-htg5">
                            <p class="act-watchText act-wth256">
                                <span class="act-line2 act-box"><span
                                        v-if="item.isSelfService"
                                        class="ui-selfRed"
                                    >自营</span>{{item.goodsName}}</span>
                            </p>
                            <div class="act-lineHtg50">
                                <span class="act-everyMonth1">每月 </span>
                                <span class="act-money24">￥</span>
                                <span class="act-money">{{item.installmentPrice}}</span>
                            </div>
                            <div class="act-mainmonth ">
                                <span
                                    v-if="false"
                                    class="ui-gold"
                                >专享</span>
                                <span class="jrm-border-1px jrm-border-homepage-all">{{item.installment}}个月免息</span>
                            </div>
                        </div>
                    </KPL>
                </p>
      </VerticalSlide>-->
            <swiper
                v-if="item.recommendGoodsList && item.recommendGoodsList.length"
                :options="swiperOption"
                ref="ActivityContent"
                style="background:#fff"
            >
                <swiper-slide
                    v-for="(item,index) in item.recommendGoodsList"
                    :key="item.id"
                    :clstag="'jr|keycount|8530052_index_content_sku|'+item.skuId+''"
                    class="home-active-slider-item"
                    :data-swiper-slide-index="index"
                >
                    <div class="home-silder-img-bg">
                        <div class="home-silder-free">{{item.installment}}期免息</div>
                        <div>
                            <img
                                class="act-banner1 act-wthhtg256 act-watch"
                                :src="item.imageUrl"
                            >
                        </div>
                    </div>
                    <div class="act-table act-wth256 act-htg5">
                        <p class="act-watchText act-wth256">
                            <span class="act-line2 act-box">
                                <span
                                    v-if="item.isSelfService"
                                    class="ui-selfRed"
                                >自营</span>
                                {{item.goodsName}}
                            </span>
                        </p>
                        <div class="act-lineHtg50">
                            <span class="act-money24">￥</span>
                            <span class="act-money">{{item.installmentPrice}}</span>
                            <span class="act-everyMonth1">每月</span>
                        </div>
                        <div class="act-mainmonth">
                            <span
                                v-if="false"
                                class="ui-gold"
                            >专享</span>
                            <!-- <span class="jrm-border-1px jrm-border-homepage-all">{{item.installment}}个月免息</span> -->
                            <span class="act-mian home-slider-payment">白条</span>
                        </div>
                    </div>
                </swiper-slide>
            </swiper>
            <SmallFloatingLayer
                class="activity-banner"
                v-if="item.isShowBanner"
                :itemAd="item.bannerInfo"
                :index="index+1"
                :itemId="item.activityId"
                :hasLastOne="index===homePageActivityList.length-1"
            ></SmallFloatingLayer>
        </div>
        <!-- <router-link
      to="/activitylist"
      class="J_ping home-check-moreWrap"
      :clstag="'jr|keycount|8530052_index_contentmore|01'"
      report-eventid="MInterestFree_GoodsMore"
      report-eventparam="1"
    >
      <span class="ui-newHomeSearch">查看更多免息好物</span>
    </router-link>-->
    </div>
</template>

<script type="text/ecmascript-6">
import request from '@/util/request';
import PictureFloatingLayer from '@/buscomponents/PictureFloatingLayer.vue';
import Headlines from '@/buscomponents/Headlines.vue';
import VerticalSlide from '@/components/VerticalSlide.vue';
import KPL from '@/buscomponents/KPL';
import SmallFloatingLayer from '@/buscomponents/SmallFloatingLayer.vue';
import 'swiper/dist/css/swiper.css';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import { openByKpl } from '../util/kpl';
import { PostSever } from '@/util/sqRequestService';
let self = null;
export default {
    name: 'HomePageActivityList',
    components: {
        PictureFloatingLayer,
        Headlines,
        VerticalSlide,
        KPL,
        SmallFloatingLayer,
        swiper,
        swiperSlide
    },
    data() {
        return {
            // 免息好物推荐标题
            recommendTitle: {
                Text: 'BEST',
                showTitle: '免息好物推荐'
            },
            sum: 2.7,
            homePageActivityList: [],
            swiperOption: {
                slidesPerView: 'auto',
                // slidesPerGroup: 2,
                // centeredSlides: true,
                // spaceBetween: '10%',
                notNextTick: true,
                speed: 1000,
                autoplay: {
                    delay: 2000,
                    disableOnInteraction: false
                },
                loop: true,
                observer: true
            }
        };
    },
    computed: {
        swiper() {
            return this.$refs.ActivityContent.swiper;
        }
    },
    created() {
        self = this;
    },
    mounted() {
        let t = setTimeout(() => {
            clearTimeout(t);
            $('.homePageActivityList').on('click', '.home-active-slider-item', function(e) {
                e.preventDefault();
                var index = $(e.currentTarget).attr('data-swiper-slide-index');
                self.handleActiveSlide(index);
            });
        }, 2000);
    },
    methods: {
        handleActiveSlide(index) {
            const _index = Number(index);
            const item = this.homePageActivityList[0].recommendGoodsList[_index];
            let open = openByKpl;
            if (this.$openByKpl) {
                open = this.$openByKpl;
            }
            if (item.skuId) {
                PostSever('//sq.jr.jd.com/cfContent/getCpsLink', {
                    skuIds: item.skuId,
                    positionId: '1816590445',
                    webId: '1277645018'
                }).then(
                    rs => {
                        open({
                            url: rs.value[0].shorUrl,
                            sku: item.skuId,
                            eventId: 'MInterestFree_GoodsContentPro',
                            eventParam: item.activityId + '_' + item.skuId
                        });
                    },
                    () => {
                        open({
                            url: item.url,
                            sku: item.skuId,
                            eventId: 'MInterestFree_GoodsContentPro',
                            eventParam: item.activityId + '_' + item.skuId
                        });
                    }
                );
            } else {
                open({
                    url: item.url,
                    sku: item.skuId,
                    eventId: 'MInterestFree_GoodsContentPro',
                    eventParam: item.activityId + '_' + item.skuId
                });
            }
        },
        loadActivityList() {
            // this.$loading.show();
            // 获取首页活动列表
            request.getHomePageActivityList({
                success: ({ homePageActivityList, yxmxBulletinBoard }) => {
                    this.$loading.hide();

                    // homePageActivityList.map(item => {
                    //   item.bannerInfo = {
                    //     imageUrl: 'https://img12.360buyimg.com/jrpmobile/jfs/t27139/122/922565173/86271/b5558787/5bbc65b4N6a2789de.jpg?width=1080&height=240',
                    //     jumpInfo: {
                    //       jumpUrl: 'https://pro.m.jd.com/mall/active/3Q7yCKKJ1bXE7Xt9USp8aKnfHs4p/index.html',
                    //       jumpType: '2',
                    //       pageType: '0'
                    //     }
                    //   };
                    // });

                    // this.homePageActivityList = homePageActivityList;
                    this.homePageActivityList = [];
                    this.yxmxBulletinBoard = yxmxBulletinBoard;
                    this.$emit('onBetterScrollRefresh');
                    this.$emit('onEditTip', yxmxBulletinBoard);
                    // this.$parent.$parent.onEditContent(yxmxBulletinBoard);
                },
                afterError: () => {
                    this.$emit('onBetterScrollRefresh');
                }
            });
        }
    },
    destroyed() {
        this.$refs = null;
        this._self = null;
    }
};
</script>

<style lang="scss">
@import '@/scss/mixin.scss';
.homePageActivityList {
    .home-vertical-slide {
        padding-left: 1rem !important;
        padding-top: 0.8rem;
        background: rgb(255, 255, 255);
    }

    .ui-selfRed {
        font-family: PingFangSC-Regular;
        font-size: $rem24;
        color: #ffffff;
        background: #f13a4d;
        padding: 0 $rem4;
        line-height: $rem28;
        height: $rem28;
        margin-right: $rem10;
    }

    .home-check-moreWrap {
        height: $rem80;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: $rem20;
        font-family: PingFangSC-Regular;
        font-size: $rem28;
        color: #333333;
        letter-spacing: 0;
        .ui-newHomeSearch {
            background: url('../assets/group27.png') no-repeat;
            background-size: $rem28 $rem28;
            background-position: center right;
            padding-right: $rem40;
        }
    }
    .act-everyMonth1 {
        font-family: PingFangSC-Regular;
        font-size: $rem24;
        color: #999999;
        letter-spacing: 0;
        padding-left: $rem8;
    }
    .act-topTip {
        font-family: PingFangSC-Regular;
        font-size: $rem20;
        color: #c29451;
        letter-spacing: 0;
    }
    .home-check-moreWrap p {
        font-family: PingFangSC-Regular;
        font-size: $rem28;
        color: #c29451;
        letter-spacing: 0;
    }
    .scrollBar_home_ellipsis {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        white-space: normal;
        text-align: left;
        padding: 0 $rem16 $rem8 0;
    }
    .act-banner1 {
        border-radius: 0;
    }
    .homePageActivityItem {
        padding-bottom: $rem20;
    }
    .activity-banner {
        margin-top: $rem20;
        margin-bottom: 0;
    }
    .act-mainmonth {
        // height: $rem32;
        margin-left: $rem8;
        text-align: left;
        white-space: nowrap;
        span {
            font-size: $rem24;
            color: $jrm-color-C29451;
            font-family: PingFangSC-Regular;
            //   display: inline-block;
            text-align: center;
            padding: $rem4 $rem6;
            line-height: $rem32;
            &.ui-gold {
                font-family: PingFangSC-Regular;
                font-size: $rem24;
                color: #ffffff !important;
                background: #c29451;
                line-height: $rem32;
                padding: $rem4 $rem10;
                // height: $rem28;
            }
        }
        .home-slider-payment {
            border-radius: 1px;
            font-size: $rem20;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            margin-right: $rem8;
            color: rgba(96, 59, 7, 1);
            padding: $rem4 $rem8;
        }
    }
    .home-silder-img-bg {
        width: $rem256;
        height: $rem256;
        overflow: hidden;
        margin: 0 auto;
        margin-bottom: $rem10;
        margin-top: $rem8;
        position: relative;
        .home-silder-free {
            padding: 0 $rem14;
            width: auto;
            position: absolute;
            left: 0;
            top: 0;
            z-index: 1;
            height: $rem40;
            background: #333333;
            font-size: $rem24;
            font-family: PingFangSC-Semibold;
            font-weight: 600;
            color: #ffffff;
            line-height: $rem40;
        }
    }
    .home-active-slider-item {
        width: $rem256 + $rem16 !important;
        overflow: initial !important;
    }
}
</style>
